import "../../App.scss"

function Blogs() {
    return (
        <div className="About">
            <div className="about-box">
                <p className="head">Blogs</p>
            </div>
        </div>
    )
}

export default Blogs